export default "__VITE_ASSET__CMdymf28__"